import printerInstance from '../instance'

const updateAutoPrintConfigs = (id, data) => {
	return printerInstance.put('/autoPrintConfigs/' + id, data)
}

export default updateAutoPrintConfigs
